<template>
  <div class="main">
    <div class="content">
      <div class="form-row-line">
        <div class="form-field">
          <router-link tag="button" to="/backoffice/documents/agreement/add">
            <span>Добавить соглашение</span>
          </router-link>
        </div>
        <div class="form-field">
          <popup-button button-text="Добавить тип соглашения">
            <add-agreement-type></add-agreement-type>
          </popup-button>
        </div>
      </div>
    </div>
    <get-agreements
      v-on:agreement-list-update="updateAgreements"
      :update-list="updateAgreementsList"
    ></get-agreements>
    <get-documents
      v-on:document-list-update="updateDocuments"
      :update-list="updateDocumentsList"
    ></get-documents>
  </div>
</template>

<script>
import addAgreementType from "components/backoffice/documents/add/AgreementType";
import getAgreements from "components/backoffice/documents/get/Agreements";
import getDocuments from "components/backoffice/documents/get/Documents";

export default {
  name: "Integration",
  components: {
    addAgreementType,
    getAgreements,
    getDocuments
  },
  data() {
    return {
      updateAgreementsList: false,
      updateDocumentsList: false
    };
  },
  computed: {},
  methods: {
    updateLists: function() {
      this.updateAgreements();
      this.updateDocuments();
    },
    updateAgreements: function() {
      this.updateAgreementsList = !this.updateAgreementsList;
    },
    updateDocuments: function() {
      this.updateDocumentsList = !this.updateDocumentsList;
    }
  },
  created() {}
};
</script>
